module.exports = __webpack_public_path__ + "img/day_item_ic2.2dda9b6a.png";